<template>
  <div class="afm-search-type-container">
    <el-select
      class="afm-search-type-select"
      v-model="searchType"
      default-first-option
      popper-class="afm-search-type-popper-class"
      :popper-append-to-body="false">
      <el-option :label="$t('brand')" value="brand" />
      <el-option :label="$t('product_name_str')" value="product_name" />
    </el-select>
  </div>
</template>

<script>
export default {
  name: "afm-search-type",
  data() {
    return {
      searchType: 'brand'
    }
  }
}
</script>

<style lang="less">
@media screen and (min-width: 768px) {
  .afm-search-type-container {
    width: 110px;

    .afm-search-type-select {
      .el-input {
        .el-input__inner {
          font-size: 15px !important;
          font-weight: 600;
        }
      }
    }

    .afm-search-type-popper-class {
      background-color: #FFFFFF;
      color: #7cc26a;

      .el-scrollbar {
        .el-select-dropdown__wrap {
          .el-scrollbar__view {
            display: unset;

            .el-select-dropdown__item {
              background-color: #FFFFFF;
              //display: block;

              span {
                font-size: 15px !important;
                font-family: Raleway;
                color: #b6b6b6;
              }
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .afm-search-type-container {
    width: 90px;

    .afm-search-type-select {
      height: 100%;
      position: relative;

      .el-input {
        height: 100%;

        .el-input__inner {
          height: 100%;
          line-height: 100%;
          font-size: 12px;
          border-top: none;
          border-left: none;
          border-bottom: none;
          border-right-width: 2px;
          font-weight: bold;
          box-shadow: none;
          font-family: 'Source Sans Pro';
          padding-left: 0;
          opacity: 0.6;
        }

        .el-input__suffix {
          .el-input__suffix-inner {
            .el-input__icon {
              line-height: 100%;
            }
          }
        }
      }
    }

    .afm-search-type-popper-class {
      background-color: #FFFFFF;
      color: #7cc26a;
      position: absolute !important;
      left: 0 !important;
      top: 16px !important;

      .el-scrollbar {
        .el-select-dropdown__wrap {
          .el-scrollbar__view {
            display: unset;

            .el-select-dropdown__item {
              background-color: #FFFFFF;
              padding: 0 5px;
              display: flex;
              align-items: center;
              justify-content: center;

              span {
                font-size: 12px;
                font-family: Raleway;
                color: rgba(0,0,0,0.6);
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/afm-search-type/afm-search-type.vue